import React from 'react';
import PropTypes from 'prop-types';
import "./../main.css"

class Collapsible extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            isExpanded: false
        }
    }

    handleToggle(e){
        e.preventDefault();
        this.setState({
            isExpanded: !this.state.isExpanded,
            height: this.refs.inner.clientHeight
        })
    }

    render(){
        const {title, children} = this.props;
        const {isExpanded} = this.state;
        const show = isExpanded ? 'block' : 'none';
        return (
            <div className={`panel ${isExpanded ? '.is-expanded' : ''}`} onClick={(e) => this.handleToggle(e)}>
                <div className="panel-heading">
                    <div class="columns">
                      <div class="is-full">{title}</div>
                    </div>
                </div>
                <div className="panel-collapse" style={{display: show}}>
                    <div className="panel-body" ref="inner">
                        {children}
                    </div>
               </div>
            </div>
        )
    }

}

Collapsible.propTypes = {
    title: PropTypes.string,
};

export default Collapsible;

